// Filename: views/layout/supervisor.js
define('views/modules/dashboard/goal/goal-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils', 'moment',
    // services
    'services/events/goal-events',
    // models & collections
    'collections/goal/goals',
    // views
    'views/modules/dashboard/goal/list/goal-list',
    // Templates
    'text!templates/modules/dashboard/goal/goal-content.html'
], function(
    // Libs
    _, Backbone, Mustache, U, moment,
    // services
    GoalEvents,
    // models & collections
    CGoals,
    // views
    VGoalList,
    // Templates
    TGoalContent
) {

    var VGoalContent = Backbone.View.extend({
        template: TGoalContent,

        regions: {
            button: '.create-goal',
            list: '.goal-list',
        },

        initialize: function(opt) {
            this.options = opt || {};

            this.group = opt.group;

            this.url = opt.url;
            this.setUrl('newDashboardGoal', '#/' + opt.url.dashboard + 'goal/new/');

            var collection = this.collection = new CGoals(),
                view = this.view = {
                    list: new VGoalList({
                        collection: collection,
                        profile: this.model,
                        group: this.group,
                        url: this.url
                    }),
                };

            this.listenTo(collection, {
                'sync': this.onCollectionSync,
            });
        },

        render: function() {
            this.initListener();
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext({
                count: _.isEmpty(this.collection.getMostRecent()) ? 0 : this.collection.getMostRecent().length,
                newDashboardGoalUrl: this.url.newDashboardGoal
            })));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.list, zone.$list);

            this.collection.getFirstPage();

            return this;
        },

        _render: function() {
            this.initListener();
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext({
                count: _.isEmpty(this.collection.getMostRecent()) ? 0 : this.collection.getMostRecent().length,
                newDashboardGoalUrl: this.url.newDashboardGoal
            })));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.list, zone.$list);

            return this;
        },

        initListener: function() {
            this.stopListeningTo(GoalEvents);
            this.listenTo(GoalEvents, {
                "goal:update": this.onGoalUpdate,
            });
        },

        resetToMostRecent: function() {
            var collection = this.collection;
            collection.reset(collection.getMostRecent(), { silent: true });
        },

        ////////////
        // events //
        ////////////

        onCollectionSync: function(collection) {
            this.resetToMostRecent();
            this._render();
        },

        onGoalUpdate: function(model) {
            var collection = this.collection;
            collection.set(model, { remove: false, silent: true });
            this.resetToMostRecent();
            this._render();
        },

        onDisable: function() {
            this.stopListeningTo(GoalEvents);
        },

    });

    return VGoalContent;

});

